module.exports = __webpack_public_path__ + "img/banner2.e88f1d72.jpg";